//@flow

import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Container, Modal, ModalHeader } from 'reactstrap';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import Jumbotron from './Jumbotron';
import BasicInformation from './BasicInformation';

import config from '../../../config';
import type { Lodge } from '../helpers';
import { Page, Loading } from '../../../components';
import { constructTitle } from '../helpers';

import ReviewsRatings from '../../../redux/containers/ReviewsRatingsContainer';
import SelectedInputs from './SelectedInputs';
import ChooseRoomType from './ChooseRoomType';
import CheckAvailability from './CheckAvailability';
import { fetchLodge } from '../../../redux/actions/lodgeActions';
import { LodgeSearchFormWrapper } from '../Common';

import './lodgeDetailNew.css';
import '../../../../node_modules/flatpickr/dist/themes/airbnb.css';
import { useToggle } from '../../../hooks';
import { appendHoneyGuide } from '../../../lib/utils';

const DEFAULT_PAX = 2;
const RATINGS_TITLES: Array<string> = [
  'Cleanliness',
  'Food',
  'Staff',
  'Value for Money',
  'Comfort',
];
type Props = RouteComponentProps & {
  lodge: Lodge,
  fetchLodge: (lodgeId: string) => void,
};

const mapStateToProps = ({ schema }, ownProps) => ({
  lodge: schema.lodgeDetail.byId[ownProps.match.params.lodgeId],
});

const mapDispatchToProps = (dispatch) => ({
  fetchLodge: (lodgeId) => dispatch(fetchLodge(lodgeId)),
});

function LodgeDetails(props: Props) {
  const chooseYourRoomEl: any = useRef(null);
  const [isAddedToCart, setIsAddedToCart] = React.useState(false);
  const { on, toggle } = useToggle();
  
  const { lodgeId } = props.match.params;
  React.useEffect(() => {
    props.fetchLodge(lodgeId);
  },[lodgeId]);
  
  const { lodge, location } = props;
  const isCanonical = Boolean(location.search);

  if (!lodge) return <Loading size="small" />;

  if (config.blockedLodgeIds.includes(lodge.id)) return null;

  return (
    <Page {...generateTagsForSEO(isCanonical)}>
      <Col className="no-gutters">
        <Container>
          <Row>
            <Col xs="12" lg="12" xl="3">
              <LodgeSearchFormWrapper />
              <LodgeSearchFormWrapper forMobile />
            </Col>

            <Col xs="12" xl="9">
              <BasicInformation
                lodgeDetail={lodge}
                onBookClick={() => {
                  chooseYourRoomEl.current.scrollIntoView({ behaviour: 'smooth' });
                }}
              />

              <Jumbotron
                className="lodge-image-holder"
                lodgeDetail={lodge}
                searchQuery={location.search}
              />

              {lodge.isBookable &&
                <div ref={chooseYourRoomEl}>
                  <SelectedInputs openModal={toggle} />
                  <ChooseRoomType
                    lodgeDetail={lodge}
                    isAddedToCart={isAddedToCart}
                    setIsAddedToCart={setIsAddedToCart}
                    openModal={toggle}
                  />
              </div>}

              <Modal toggle={toggle} isOpen={on} className="check-availability">
                <ModalHeader toggle={toggle}>Check Availability</ModalHeader>
                <CheckAvailability onSuccess={toggle} />
              </Modal>

              <ReviewsRatings ratingsTitles={RATINGS_TITLES} origin="lodge" />
            </Col>
          </Row>
        </Container>
      </Col>
    </Page>
  );

  function generateTagsForSEO(isCanonical) {
    const {
      lodge: { name, address, region, bannerImages, isBookable, startingPrice },
      location: { pathname },
    } = props;

    const nameAddressRegion = constructTitle({ name, address, region });
    const title = isBookable  ? `Book ${nameAddressRegion} from ${startingPrice.currency} ${startingPrice.amount * DEFAULT_PAX}` : nameAddressRegion;

    return {
      title: appendHoneyGuide(title),
      image: bannerImages ? `${config.RESOURCE_URL}/${bannerImages.medium}` : '',
      ...(isCanonical
        ? { canonicalUrl: `${config.appUrl}${pathname}`, noCrawl: true }
        : {}),
    };
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LodgeDetails)
);



// WEBPACK FOOTER //
// ./src/screens/Lodge/Details/LodgeDetails.js